module.exports = __webpack_public_path__ + "static/media/newcity.3df7e94e.png";